import { PostDTO } from '../dto'

export const MockPosts: PostDTO[] = [
    {
        _id: '655a00c0cb473a105817743b',
        name: 'Đinh Hiểu Khánh',
        yearofbirth: 305,
        hometown: 'https://www.facebook.com/skillcetera/videos/371616955223715/',
        reach: 48932,
        engagement: 1911,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Ff564c5ee-79bd-4477-8ae8-68e5dde9610c?alt=media&token=340279f8-db94-42de-97bf-88a47f80fa1d',
        path_image_firebase: 'top30/2023/11/19/f564c5ee-79bd-4477-8ae8-68e5dde9610c',
        video_url: 'AVJHxRH47BQ',
        __v: 0
    },
    {
        _id: '655a0111cb473a1058177442',
        name: 'Dương Đinh Thái Uyên',
        yearofbirth: 567,
        hometown: 'https://www.facebook.com/skillcetera/videos/1300550337266456',
        reach: 1076,
        engagement: 228,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F336de95d-9502-4676-ba89-2013825a7ada?alt=media&token=2cc9ccd8-e439-4f0f-81a7-f32461bf6216',
        path_image_firebase: 'top30/2023/11/19/336de95d-9502-4676-ba89-2013825a7ada',
        video_url: '14cCkaoq98w',
        __v: 0
    },
    {
        _id: '655a018bcb473a1058177446',
        name: 'Nguyễn Ngọc Quỳnh Giao',
        yearofbirth: 907,
        hometown: 'https://www.facebook.com/skillcetera/videos/1856262884845578',
        reach: 1064,
        engagement: 154,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F0ffc44ef-b8d7-4350-929c-b83c70b2db13?alt=media&token=659befd3-df1a-4eac-ab66-c7017ef837a2',
        path_image_firebase: 'top30/2023/11/19/0ffc44ef-b8d7-4350-929c-b83c70b2db13',
        video_url: '-K_iRN1doKM',
        __v: 0
    },
    {
        _id: '655a01c5cb473a105817744a',
        name: 'Dư Lê Chí Hào',
        yearofbirth: 228,
        hometown: 'https://www.facebook.com/skillcetera/videos/653773476966058',
        reach: 3428,
        engagement: 761,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F337af589-7df3-4100-a0d6-eeee5e2447be?alt=media&token=d8f33bb1-1d10-4451-a734-607a4c6b6100',
        path_image_firebase: 'top30/2023/11/19/337af589-7df3-4100-a0d6-eeee5e2447be',
        video_url: '60BprZ5HyF4',
        __v: 0
    },
    {
        _id: '655a0226cb473a105817744e',
        name: 'Đồng Xuân Bảo Long',
        yearofbirth: 141,
        hometown: 'https://www.facebook.com/skillcetera/videos/366285795797771',
        reach: 4283,
        engagement: 1363,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F7de737e5-8d7b-430c-a2c2-8fcccdac52c2?alt=media&token=e2a9da84-076d-4e2c-8360-e5d5d6dad065',
        path_image_firebase: 'top30/2023/11/19/7de737e5-8d7b-430c-a2c2-8fcccdac52c2',
        video_url: 'Z1uOgV0SC5Q',
        __v: 0
    },
    {
        _id: '655a0252cb473a1058177452',
        name: 'Lê Khánh Hà',
        yearofbirth: 424,
        hometown: 'https://www.facebook.com/skillcetera/videos/276308084900489',
        reach: 3264,
        engagement: 1055,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F80bd6a60-23a6-4950-928e-907a1ac3d514?alt=media&token=20a0b652-d13c-4fed-9abc-66d0eba5b5fb',
        path_image_firebase: 'top30/2023/11/19/80bd6a60-23a6-4950-928e-907a1ac3d514',
        video_url: '84UF7SNUFb4',
        __v: 0
    },
    {
        _id: '655a0278cb473a1058177456',
        name: 'Trần Lê Minh Thư',
        yearofbirth: 447,
        hometown: 'https://fb.watch/ou_g1PI2Ji/',
        reach: 1155,
        engagement: 241,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fb920226f-8c5c-4006-8225-8cc418634d7c?alt=media&token=c8650523-4829-44b3-9c31-f709d46f3a3e',
        path_image_firebase: 'top30/2023/11/19/b920226f-8c5c-4006-8225-8cc418634d7c',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a02ebcb473a105817745a',
        name: 'Trần Ngọc Bảo Trân',
        yearofbirth: 299,
        hometown: 'https://fb.watch/ou_gOYK5UU/',
        reach: 1885,
        engagement: 787,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F3fd79215-6562-4238-9245-0ce975c15fe2?alt=media&token=333d7d36-67c4-4e9b-99c5-a7eeca633502',
        path_image_firebase: 'top30/2023/11/19/3fd79215-6562-4238-9245-0ce975c15fe2',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a0414cb473a1058177464',
        name: 'Nguyễn Dương Gia Bảo',
        yearofbirth: 41,
        hometown: 'https://www.facebook.com/skillcetera/videos/657238892955006',
        reach: 1301,
        engagement: 358,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Ffdbf968a-42ff-4f0d-afad-e3fe5843e665?alt=media&token=46427fe6-1d16-4176-9722-5c4a85bdc128',
        path_image_firebase: 'top30/2023/11/19/fdbf968a-42ff-4f0d-afad-e3fe5843e665',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a046dcb473a1058177468',
        name: 'Lê Huỳnh Hải Yến',
        yearofbirth: 331,
        hometown: 'https://www.facebook.com/skillcetera/videos/897606455314343',
        reach: 2049,
        engagement: 712,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F005e7b20-eff4-4cb6-950a-b84d235ddcde?alt=media&token=a8669c5b-7bb4-40cd-8c7a-b1f15d127215',
        path_image_firebase: 'top30/2023/11/19/005e7b20-eff4-4cb6-950a-b84d235ddcde',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a04e0cb473a105817746c',
        name: 'Trương Mộng Huyền',
        yearofbirth: 153,
        hometown: 'https://www.facebook.com/skillcetera/videos/882381556940872',
        reach: 3783,
        engagement: 1358,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F52c12654-f7c5-4531-91d5-bdc7445c93ea?alt=media&token=bf1ecf37-84a6-4393-89f4-ee06906ad5eb',
        path_image_firebase: 'top30/2023/11/19/52c12654-f7c5-4531-91d5-bdc7445c93ea',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a0809cb473a105817747a',
        name: 'Võ Phương Mỹ',
        yearofbirth: 150,
        hometown: 'https://www.facebook.com/skillcetera/videos/1468797413977585',
        reach: 403,
        engagement: 63,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fce6162b3-cc2c-4993-920a-c4a627f5f529?alt=media&token=6acf6af7-f8f1-48e6-8690-721e31cf341f',
        path_image_firebase: 'top30/2023/11/19/ce6162b3-cc2c-4993-920a-c4a627f5f529',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a0863cb473a105817747e',
        name: 'Võ Nguyễn Thiên Thanh',
        yearofbirth: 11,
        hometown: 'https://www.facebook.com/skillcetera/videos/1779180315851109',
        reach: 657,
        engagement: 125,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Ff065c88f-6e72-4721-ac6c-4d7e928d840c?alt=media&token=400aab78-91b0-4266-be90-a4e6dc4c001e',
        path_image_firebase: 'top30/2023/11/19/f065c88f-6e72-4721-ac6c-4d7e928d840c',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a08bccb473a1058177482',
        name: 'Nguyễn Huỳnh Khánh Nhi',
        yearofbirth: 650,
        hometown: 'https://www.facebook.com/skillcetera/videos/2019775141735667',
        reach: 2765,
        engagement: 1295,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F3a18bfee-00bd-4b7b-8c1e-6967faf4f2f7?alt=media&token=c53bd176-17f2-482c-b988-d71dab384d2e',
        path_image_firebase: 'top30/2023/11/19/3a18bfee-00bd-4b7b-8c1e-6967faf4f2f7',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a08e7cb473a1058177486',
        name: 'Nguyễn Đình Quang Đạo',
        yearofbirth: 745,
        hometown: 'https://www.facebook.com/skillcetera/videos/667296008845627',
        reach: 509,
        engagement: 139,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F70229bc1-6a0e-4416-afcd-a41c04b192f2?alt=media&token=7e51bcc7-1641-4185-bd70-460d42ffc861',
        path_image_firebase: 'top30/2023/11/19/70229bc1-6a0e-4416-afcd-a41c04b192f2',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a090acb473a105817748a',
        name: 'Nguyễn Như Bình',
        yearofbirth: 667,
        hometown: 'https://www.facebook.com/skillcetera/videos/329206809828138',
        reach: 1161,
        engagement: 601,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fa09eeb58-8080-441c-9dc5-e37a02c0a6f5?alt=media&token=c7127bec-1165-43e6-9db3-2c6536d322db',
        path_image_firebase: 'top30/2023/11/19/a09eeb58-8080-441c-9dc5-e37a02c0a6f5',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a0937cb473a105817748e',
        name: 'Nguyễn Trần Công Minh',
        yearofbirth: 477,
        hometown: 'https://www.facebook.com/skillcetera/videos/1400476504179775',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F22a0b584-6356-428e-9a8e-85f9c05566b9?alt=media&token=356a40b6-914c-4905-a859-c777eeefca54',
        path_image_firebase: 'top30/2023/11/19/22a0b584-6356-428e-9a8e-85f9c05566b9',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a098acb473a1058177492',
        name: 'Lê Thị Bình Minh',
        yearofbirth: 699,
        hometown: 'https://www.facebook.com/skillcetera/videos/3503276429925734',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fd621fda4-c7ff-4bdb-909d-655d75c3c451?alt=media&token=8b00c303-622f-46a6-80b9-36322442d461',
        path_image_firebase: 'top30/2023/11/19/d621fda4-c7ff-4bdb-909d-655d75c3c451',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a09f9cb473a1058177496',
        name: 'Tô Mỹ Đình',
        yearofbirth: 363,
        hometown: 'https://www.facebook.com/skillcetera/videos/656092923350974',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fee371282-6d99-47ca-9b1f-016f7d22576b?alt=media&token=185e0503-be99-4555-a712-f43b5345d59c',
        path_image_firebase: 'top30/2023/11/19/ee371282-6d99-47ca-9b1f-016f7d22576b',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a0a35cb473a105817749a',
        name: 'Lương Hạnh Giang',
        yearofbirth: 469,
        hometown: 'https://www.facebook.com/skillcetera/videos/1033585921192485',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F3c349545-b37f-45c0-a9d0-acf4643d8eb9?alt=media&token=27ef8b3b-84c7-4e58-b50b-15238ce5f8be',
        path_image_firebase: 'top30/2023/11/19/3c349545-b37f-45c0-a9d0-acf4643d8eb9',
        video_url: '1-iepQP4n4w',
        __v: 0
    },
    {
        _id: '655a0a5dcb473a105817749e',
        name: 'Võ Ngọc Phương Linh',
        yearofbirth: 559,
        hometown: 'https://www.facebook.com/skillcetera/videos/1025837992003680',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fc790a3cd-76aa-497c-92b4-27e4f80c2878?alt=media&token=a3e6993f-3ae4-4b32-9d8e-9bba9de06cf2',
        path_image_firebase: 'top30/2023/11/19/c790a3cd-76aa-497c-92b4-27e4f80c2878',
        video_url: 'Z1uOgV0SC5Q',
        __v: 0
    },
    {
        _id: '655a0a8ccb473a10581774a2',
        name: 'Ngô Bá Thịnh',
        yearofbirth: 381,
        hometown: 'https://www.facebook.com/skillcetera/videos/875088163920109',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2F426664be-6465-4567-b982-084521d5f21d?alt=media&token=5ecd7226-d9b3-4820-a895-25fad30ee01e',
        path_image_firebase: 'top30/2023/11/19/426664be-6465-4567-b982-084521d5f21d',
        video_url: '84UF7SNUFb4',
        __v: 0
    },
    {
        _id: '655a0ab5cb473a10581774a6',
        name: 'Trần Như Anh Ngữ',
        yearofbirth: 147,
        hometown: 'https://www.facebook.com/skillcetera/videos/866310048615359',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fe3f8bba4-0fed-4111-82e3-9aede0763357?alt=media&token=eabce829-114d-49ff-95f4-2b4d95c4f0c6',
        path_image_firebase: 'top30/2023/11/19/e3f8bba4-0fed-4111-82e3-9aede0763357',
        video_url: '84UF7SNUFb4',
        __v: 0
    },
    {
        _id: '655a0adacb473a10581774aa',
        name: 'Lê Nguyễn Trường Huy',
        yearofbirth: 931,
        hometown: 'https://www.facebook.com/skillcetera/videos/365054012580671',
        reach: 0,
        engagement: 0,
        image_url:
            'https://firebasestorage.googleapis.com/v0/b/skillcetera-services.appspot.com/o/top30%2F2023%2F11%2F19%2Fc0a4d7be-b74b-4fd4-9f31-af5c91da2fb3?alt=media&token=aa0eae1e-0e55-4a58-a30e-076f6fe33532',
        path_image_firebase: 'top30/2023/11/19/c0a4d7be-b74b-4fd4-9f31-af5c91da2fb3',
        video_url: '84UF7SNUFb4',
        __v: 0
    }
]
